import React from "react";
import PropTypes from "prop-types";
import { STATUS_SUMMARY_CHIPS } from "../../utils/statusSummaryChips";
import "./StatusSummaryChips.css";

const StatusSummaryChips = ({ counts, activeKey, onSelect, onClear }) => {
  return (
    <div
      className="status-summary-chips"
      role="group"
      aria-label="PAF status summary"
    >
      {STATUS_SUMMARY_CHIPS.map((chip) => {
        const count = counts?.[chip.key] ?? 0;
        const isActive = activeKey === chip.key;

        return (
          <button
            key={chip.key}
            type="button"
            className={`status-summary-chip status-summary-chip--${chip.key}${
              isActive ? " is-active" : ""
            }`}
            aria-pressed={isActive}
            onClick={() => onSelect(chip)}
          >
            <span className="status-summary-chip-label">
              {chip.label} ({count})
            </span>
            <span
              className="status-summary-chip-clear"
              role="button"
              tabIndex={0}
              aria-label={`Clear ${chip.label} filter`}
              onClick={(event) => {
                event.stopPropagation();
                if (isActive) onClear();
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  event.stopPropagation();
                  if (isActive) onClear();
                }
              }}
            >
              ×
            </span>
          </button>
        );
      })}
    </div>
  );
};

StatusSummaryChips.propTypes = {
  counts: PropTypes.objectOf(PropTypes.number),
  activeKey: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default StatusSummaryChips;
